export default __webpack_public_path__ + "static/media/long-arrow-down.91c78c25.svg";